<template>
  <v-app>
    <v-app-bar app dark color="primary">
      <div class="d-flex align-center">
        <v-img
          alt="Viatil"
          class="shrink mr-2"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          width="40"
        />
      </div>
      <span class="text-center titlename">Da Alicia</span>
    </v-app-bar>

    <v-content>
      <a id="homebar"></a>
      <v-snackbar multi-line :timeout="3000" v-model="snackbar">
        <v-icon color="error" class="pr-3">mdi-alert</v-icon>
        {{ text }}
        <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Productos</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">Selección del destino</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Finalizar pedido</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="2" class="py-0">
            <div class="title-overmap subtitle-1 font-weight-light">
              <span style="display:block" class="pr-6">
                Presione continuar
                <v-icon>mdi-forward</v-icon>si desea el pedido para su posición actual
              </span>
              <v-icon>mdi-cursor-pointer</v-icon>
              <span class="caption">También puede seleccionar otro destino</span>

              <br />
              <v-text-field
                v-if="admin"
                dense
                class="subtitle-1 font-weight-light"
                v-model="direccion"
                readonly
                single-line
                label="Dirección"
              ></v-text-field>
            </div>
            <div class="d-flex justify-center">
              <v-btn class="ml-5 my-2" text @click="goUp(1)" style="z-index:2;">Volver</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="my-2" color="primary" @click="goToLast" style="z-index:2;">
                Continuar
                <v-icon>mdi-forward</v-icon>
              </v-btn>
            </div>
            <Mapbox :autosearch="geo" @coordinates="coordinateEvent" ref="mapa" />
          </v-stepper-content>

          <v-stepper-content step="1">
            <v-carousel
              v-show="hidecarousel"
              hide-delimiters
              :cycle="false"
              height="200"
              hide-delimiter-background
              show-arrows-on-hover
              v-model="carouselindex"
              id="compras"
            >
              <v-carousel-item v-for="(slide, i) in slideproducts" :key="i">
                <v-sheet color="black" height="100%">
                  <v-img contain class="steper" :src="requireImg(slide.img)">
                    <v-btn class="float-right" tile @click="addPredefindedProduct(slide)">
                      <span>
                        <v-icon>mdi-eye</v-icon>Ver
                      </span>
                    </v-btn>
                    <div class="nameprod body-2 text-truncate">{{slide.producto}}</div>
                  </v-img>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
            <v-card class="mb-12 mx-1">
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-select
                    :items="slides"
                    dense
                    :append-outer-icon="!!productform.producto?'mdi-close':undefined"
                    @input="addPredefindedProduct"
                    @click:append-outer="resetForm"
                    :rules="[v => !!v || 'El producto es requerido']"
                    v-model="productform.producto"
                    class="mt-2"
                    label="Seleccione los productos"
                    outlined
                  >
                    <template v-slot:selection="data">
                      <span class="my-2 red--text">{{ data.item.producto }}</span>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title class="text-no-wrap">{{data.item.producto}}</v-list-item-title>
                        <v-list-item-subtitle>
                          ${{data.item.precio.toFixed(2)}}
                          <br />
                          {{data.item.descripcion}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                  {{productform.descripcion}}
                  <v-row>
                    <v-col class="d-flex py-0" cols="12" sm="6">
                      <v-text-field
                        suffix="Unidades"
                        id="unidades"
                        :rules="[v => (!!v && v>0) || 'La cantidad es requerida']"
                        v-model="productform.cantidad"
                        label="Cantidad"
                        type="number"
                        min="1"
                        value="1"
                        hide-details
                        single-line
                        ref="cantidades"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <span v-if="productform.precio" class="font-weight-medium">$ {{changePrecio}}</span>
                <v-spacer></v-spacer>
                <v-btn depressed @click="addProduct" color="success">
                  <v-icon>mdi-cart-plus</v-icon>Adicionar
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-divider></v-divider>
            <v-subheader>
              <v-icon>mdi-shopping</v-icon>
              <span class="pt-2">Listado de productos</span>
              <v-spacer></v-spacer>
              <b>${{costo}}</b>
            </v-subheader>

            <v-list class="mb-2">
              <v-slide-y-transition class="py-0" group>
                <v-list-item class="px-0" v-for="(item, index) in products" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>{{item.producto}}</v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="caption red--text">
                        <b>{{item.place}}</b>
                      </span>
                      <br />
                      {{item.cantidad}} Unidad(es) - $ {{item.precio.toFixed(2)}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="deleteProduct(index)">
                      <v-icon color="grey lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-slide-y-transition>
            </v-list>
            <v-row class="mt-10">
              <v-spacer></v-spacer>
              <v-btn class="mr-5" color="primary" @click="goToSecond">Continuar</v-btn>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <div class="headline font-weight-thin mb-5">
              Su compra en:
              <b>{{buyplace}}</b>
            </div>

            <div class="headline font-weight-thin mb-5">
              <v-row>
                <v-col>
                  Productos:
                  <br />
                  <b>${{costo}}</b>
                </v-col>
                <v-col>
                  Envio:
                  <br />
                  <b>${{cotizacion.precio}}</b>
                </v-col>
                <v-col>
                  Total:
                  <br />
                  <b>
                    <span
                      class="red--text"
                    >${{(parseFloat(cotizacion.precio)+ parseFloat(costo)).toFixed(2)}}</span>
                  </b>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-container fluid>
              <v-radio-group v-model="cliente.tarjeta">
                <v-row>
                  <v-col>
                    <span class="font-weight-medium">Pago en:</span>
                  </v-col>
                  <v-col>
                    <v-radio label="Efectivo" :value="false"></v-radio>
                  </v-col>
                  <v-col>
                    <v-radio label="Tarjeta" :value="true"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <div class="font-weight-medium text-center py-0">Factura:</div>
              <v-radio-group class="py-0 my-0" v-model="cliente.datos">
                <v-row>
                  <v-col>
                    <v-radio label="Sin Factura" :value="false"></v-radio>
                  </v-col>
                  <v-col>
                    <v-radio label="Con Factura" :value="true"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <div class="font-weight-medium text-center py-0 my-0">
                <v-row>
                  <v-col class="mt-1">Reservar para luego:</v-col>
                  <v-col class="my-0">
                    <v-switch
                      class="caption my-0"
                      v-model="cliente.reserva"
                      :label="(cliente.reserva)?'SI':'NO'"
                    ></v-switch>
                  </v-col>
                </v-row>
              </div>
              <v-form ref="formdatos" v-model="closevalid">
                <v-row justify="space-around">
                  <v-col>
                    <v-menu v-model="dateshow" :close-on-content-click="false">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :rules="(cliente.reserva)?[v => !!v || 'La fecha es requerida']:[]"
                          v-show="cliente.reserva"
                          v-model="cliente.fechareserva"
                          label="Fecha"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        no-title
                        :max="monthahead"
                        :min="actualdate"
                        @change="dateshow = !dateshow"
                        v-model="cliente.fechareserva"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu v-model="timeshow" :close-on-content-click="false">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :rules="(cliente.reserva)?[v => !!v || 'La hora es requerida']:[]"
                          v-show="cliente.reserva"
                          v-model="cliente.horareserva"
                          label="Hora"
                          outlined
                          prepend-inner-icon="mdi-clock-outline"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        @change="timeshow = !timeshow"
                        format="24hr"
                        v-model="cliente.horareserva"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-text-field
                  :rules="[v => !!v || 'El nombre es requerido']"
                  ref="nombre"
                  v-model="cliente.nombre"
                  label="Nombre"
                  outlined
                ></v-text-field>
                <v-text-field
                  :rules="[v => !!v || 'La dirección es requerida']"
                  v-model="cliente.direccion"
                  label="Dirección"
                  clearable
                  outlined
                ></v-text-field>
                <v-text-field
                  :rules="(cliente.datos)?[v => !!v || 'El CI es requerido']:[]"
                  v-show="cliente.datos"
                  v-model="cliente.cedularuc"
                  label="CI"
                  outlined
                ></v-text-field>
                <v-text-field
                  :rules="(cliente.datos)?[v => !!v || 'El teléfono es requerido']:[]"
                  v-show="cliente.datos"
                  v-model="cliente.telefono"
                  label="Teléfono"
                  outlined
                ></v-text-field>
                <v-text-field
                  :rules="(cliente.datos)?[v => !!v || 'El correo es requerido']:[]"
                  v-show="cliente.datos"
                  v-model="cliente.correo"
                  label="Correo"
                  outlined
                ></v-text-field>
                <v-textarea v-model="adicional" label="Información adicional" outlined></v-textarea>
              </v-form>
            </v-container>
            <v-alert
              outlined
              type="info"
              prominent
              border="left"
              class="caption"
            >Su solicitud será procesada por una operadora que se pondrá en contacto con ud vía Whatsapp.</v-alert>

            <v-row class="mt-10">
              <v-btn class="ml-5" text @click="goUp(2)">Volver</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="mr-5" color="primary" @click="close">Finalizar</v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
    <v-overlay :opacity="0.94" :value="overlay">
      <v-row align="center" justify="center">
        <template v-if="status=='Procesando'">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </template>
        <template v-else-if="status=='Completado'">
          <span style="max-width:80%" class="text-justify">
            Pedido recibido, le enviaremos por Whatsapp el detalle de su pedido y estableceremos contacto con usted para puntualizar detalles de la entrega. Gracias por preferirnos.
            <br />Haga click en el boton para continuar
          </span>
          <v-icon @click="openWS" size="100" color="green">mdi-check-circle-outline</v-icon>
        </template>
        <template v-else>
          <div>{{status}}</div>
          <v-icon @click="openWS" size="100">mdi-alert-circle-outline</v-icon>
        </template>
      </v-row>
    </v-overlay>
  </v-app>
</template>

<script>
import Mapbox from "@/components/Mapbox";
import moment from "moment/src/moment";
import * as axios from "axios";

export default {
  name: "User",
  components: {
    Mapbox
  },
  mounted() {},
  computed: {
    costo: function() {
      return this.products
        .map(el => el.precio)
        .reduce((a, b) => a + b, 0)
        .toFixed(2);
    },
    changePrecio: function() {
      return (this.productform.precio * this.productform.cantidad).toFixed(2);
    },
    slideproducts: function() {
      return this.slides.filter(el => !el.header && el.img);
    },
    selectedPlaces: function() {
      return [...new Set(this.products.map(el => el.place))];
    },
    midlepoints: function() {
      return this.places
        .filter(el => this.selectedPlaces.indexOf(el.place) > -1)
        .map(el => [el.lng, el.lat]);
    }
  },
  methods: {
    coordinateEvent(data) {
      this.geo = data;
      this.getAddress([this.geo.lng, this.geo.lat]);
    },
    addPredefindedProduct(item) {
      this.productform = {
        producto: item,
        id: item.id,
        cantidad: 1,
        precio: item.precio,
        descripcion: item.descripcion
      };
      this.$vuetify.goTo("#compras");
      this.$refs.cantidades.$el.focus();
      const slideindex = this.slideproducts.findIndex(el => item._id === el._id);
      this.carouselindex = slideindex > 0 ? slideindex : this.carouselindex;
    },
    addProduct() {
      this.$refs.form.validate();
      if (this.valid) {
        const productToCar = Object.assign({}, this.productform.producto);
        productToCar.precio =
          this.productform.producto.precio * this.productform.cantidad;
        productToCar.cantidad = this.productform.cantidad;
        this.products.push(productToCar);
        this.resetForm();
        this.$refs.form.resetValidation();
      }
    },
    resetForm() {
      this.productform = {
        producto: "",
        cantidad: 1
      };
    },
    requireImg(name) {
      return name
      // return name ? require(`@/assets/${name}`) : require("@/assets/logo.png");
    },
    deleteProduct(index) {
      this.products = this.products.filter((_, i) => index !== i);
    },
    goUp(step) {
      this.step = step;
      setTimeout(() => {
        this.$vuetify.goTo("#homebar");
        if (step == 2) {
          this.$refs.mapa.updateSize();
        } else {
          this.$refs.mapa.unresize();
        }
      }, 500);
    },
    goToLast() {
      if (this.geo.lat === 0) {
        this.text = "Debe ubicar el destino";
        this.snackbar = true;
      } else {
        this.updateRoute();
        this.goUp(3);
      }
    },
    goToSecond() {
      if (this.products.length > 0) {
        this.goUp(2);
      } else {
        this.text = "Debe adicionar al menos un producto.";
        this.snackbar = true;
      }
    },
    close() {
      this.$refs.formdatos.validate();
      if (this.closevalid) {
        this.overlay = true;
        this.$socket.client.emit(
          "pedido",
          {
            valor_productos: this.costo,
            valor_envio: this.cotizacion.precio,
            distancia: this.cotizacion.distancia,
            tiempo_recorrido: this.cotizacion.tiempo,
            pedido: this.products,
            buscar: this.buscar,
            place: this.placeid,
            ubicacion: this.geo,
            cliente: this.cliente,
            adicional: this.adicional
          },
          ack => {
            if (ack == "OK") {
              this.status = "Completado";
            } else {
              this.status = "Ha ocurrido un error procesando su pedido";
            }
          }
        );
      }
    },
    updateRoute() {
      // overwrite any existing layers
      this.$socket.client.emit(
        "cotizar",
        { lng: this.geo.lng, lat: this.geo.lat },
        datos => {
          this.cotizacion.precio = datos.precio;
          this.cotizacion.distancia = datos.distancia;
          this.buyplace = datos.lugar;
          this.placeid = datos.placeid;
        }
      );
      this.cliente.direccion =
        JSON.stringify(this.geo) == JSON.stringify(this.cliente.geo)
          ? this.cliente.direccion
          : "";
    },
    getAddress(e) {
      const me = this;
      axios
        .get(
          `https://geosecure.xoaserver.com/reverse?lon=${e[0]}&lat=${e[1]}` //Url a donde la enviaremos
        )
        .then(data => {
          const jsonResponse = data.data.features;
          if (jsonResponse.length > 0) {
            if (
              jsonResponse[0].properties.street &&
              jsonResponse[0].properties.name
            ) {
              me.direccion =
                jsonResponse[0].properties.street +
                " - " +
                jsonResponse[0].properties.name;
            } else if (jsonResponse[0].properties.name) {
              me.direccion = jsonResponse[0].properties.name;
            } else {
              me.direccion = jsonResponse[0].properties.street;
            }
          }
        });
      // axios
      //   .get(
      //     `https://api.mapbox.com/geocoding/v5/mapbox.places/${e.join(",")}.json?country=ec&language=es&access_token=pk.eyJ1IjoiZG9nY2FsYXMiLCJhIjoiY2p1MDdjb2Q4MW1mMzRkcGZleWM0cmd5eiJ9.HSK77-donn1vBcZyHSV4Hg`
      //   )
      //   .then(jsonResponse => {
      //     jsonResponse = jsonResponse.data;
      //     if (jsonResponse.length > 0) {
      //       console.log(jsonResponse);
      //       // me.direccion = jsonResponse[0]
      //     }
      //   });
    },
    createHeaders(productos) {
      const tempheaders = [...new Set(productos.map(el => el.place))];
      const headers = [];
      let result = [];

      for (const head of tempheaders) {
        headers[head] = [];
      }
      for (const prod of productos) {
        headers[prod.place].push(prod);
      }
      for (const header of tempheaders) {
        result.push({ header });
        result = result.concat([...headers[header]]);
      }
      return result;
    },
    openWS() {
      window.location.href = "https://wa.me/5351321939";
    }
  },
  sockets: {
    connect() {
      console.log("socket connected");
    },
    start(data) {
      if (data.message) {
        this.status = data.message;
      } else if (data.products.length > 0) {
        this.admin = data.admin == "true";
        this.overlay = false;
        if (data.products.length > 0) {
          this.slides = this.createHeaders(data.products);
        }
        if (data.client) {
          Object.assign(this.cliente, data.client);
          if (data.client.geo) {
            this.geo = data.client.geo;
            this.direccion = data.client.direccion;
          }
        }
      } else {
        this.status = "Ha ocurrido un error cargando los productos.";
      }
    },
    close() {
      this.status = "Conectando ...";
    }
  },
  data: () => ({
    admin: false,
    cotizacion: {
      tiempo: 0,
      distancia: 0,
      precio: 0
    },
    closevalid: false,
    buyplace: "Chaulao",
    placeid: "",
    buscar: false,
    monthahead: moment()
      .add(1, "months")
      .toISOString(),
    actualdate: moment().toISOString(),
    timeshow: false,
    direccion: "",
    dateshow: false,
    carouselindex: 0,
    overlay: true,
    status: "Procesando",
    valid: true,
    hidecarousel: true,
    geo: { lat: 0, lng: 0 },
    productform: {
      id: null,
      producto: "",
      cantidad: 1
    },
    snackbar: false,
    text: "Debe adicionar al menos un producto.",
    step: 1,
    adicional: "",
    cliente: {
      nombre: "",
      telefono: "",
      direccion: "",
      cedularuc: "",
      correo: "",
      tarjeta: false,
      datos: false,
      reserva: false,
      fechareserva: "",
      horareserva: ""
    },
    products: [],
    slides: [],
    places: [
      {
        place: "Chaulao",
        lat: -2.1335,
        lng: -79.897469
      }
    ]
  })
};
</script>

<style scoped>
.title-overmap {
  /* border-left: 4px solid #000; */
  position: absolute;
  width: 85vw;
  z-index: 2;
  color: rgb(104, 104, 104);
  background-color: rgba(255, 255, 255, 0.895);
  margin: 5px;
  margin-top: 58px;
  padding: 4px;
}

.steperfood {
  height: 20px;
}
.nameprod {
  position: absolute;
  /* width: 100%; */
  display: block;
  top: 166px;
  /* text-align: center; */
  padding: 5px;
  color: black;
  background-color: rgba(255, 255, 255, 0.8);
}
.titlename {
  font-family: Manjari, sans-serif;
  color: #030080;
  margin-top: 7px;
  font-size: x-large;
}
</style>

<style>
@import url("https://fonts.googleapis.com/css2?family=Manjari:wght@700&display=swap");
.steper > .v-image__image {
  height: 200px !important;
}
#input-35 {
  display: none;
}
</style>